import React, { ReactNode } from 'react'

import { BackButton } from 'components/back-button/BackButton'
import { H1 } from 'components/heading/Heading'

import { Step, StepProps } from '../stepper/Step'
import Stepper from '../stepper/Stepper'

import s from './SplitLayout.module.scss'

type Props = {
  image?: string
  subTitle?: string
  title?: string
  summary?: string
  children: ReactNode
  video?: ReactNode
  goBack?: () => void
  steps?: Array<Omit<StepProps, 'activeStep' | 'index'>>
  currentStep?: number
}

export const SplitLayout = (props: Props) => {
  const {
    subTitle,
    title,
    summary,
    children,
    video,
    goBack,
    steps,
    currentStep,
  } = props

  const image = props.image ? props.image : ''

  return (
    <div className={s.splitLayout}>
      <div className={s.splitLayout__left}>
        {steps !== undefined && currentStep !== undefined && (
          <Stepper>
            {steps.map((item, i) => (
              <Step
                key={i}
                {...(item as StepProps)}
                index={i}
                activeStep={currentStep}
              />
            ))}
          </Stepper>
        )}

        {goBack && <BackButton onClick={goBack}>Til baka</BackButton>}

        <div className={s.splitLayout__heading}>
          {subTitle && <h3 className={s.splitLayout__subTitle}>{subTitle}</h3>}
          {title && <H1 className={s.splitLayout__title}>{title}</H1>}

          {summary && <p className={s.splitLayout__summary}>{summary}</p>}
        </div>
        <div className={s.spiltLayout__content}>{children}</div>
      </div>

      <div className={s.splitLayout__right}>
        {video ? (
          <div className={s.splitLayout__video}>{video}</div>
        ) : (
          image && (
            <div
              className={s.splitLayout__image}
              style={{ backgroundImage: `url(${image})` }}
            />
          )
        )}
      </div>
    </div>
  )
}
